import { Map, fromJS } from "immutable";
import { defaultContext } from "@biuwer/redux/src/config/constants";

import { HOME_INITIALIZE, HOME_PRODUCT_UPDATES_INITIALIZE, HOME_PRODUCT_UPDATES_FETCH_REQUEST, HOME_PRODUCT_UPDATES_FETCH_SUCCESS, HOME_PRODUCT_UPDATES_FETCH_ERROR } from "./home-actions.js";

const initialState = fromJS({
    product_updates_primary: {}
});

const home = (state = initialState, action) => {
    let newState;

    // Get product updates context
    const productUpdates = `product_updates_${(action && action.context) || defaultContext}`;

    switch (action.type) {
        // Initialization
        case HOME_INITIALIZE:
            newState = state.setIn([productUpdates], Map({}));
            return newState;

        case HOME_PRODUCT_UPDATES_INITIALIZE:
            newState = state.setIn([productUpdates], Map({}));
            return newState;

        // Product Updates fetch
        case HOME_PRODUCT_UPDATES_FETCH_REQUEST:
            newState = state.mergeIn([productUpdates], Map({
                isFetching: action.isFetching,
                error: action.error
            }));
            return newState;

        case HOME_PRODUCT_UPDATES_FETCH_SUCCESS:
            newState = state.mergeIn([productUpdates], Map({
                isFetching: action.isFetching,
                error: action.error,
                payload: fromJS(action.payload)
            }));
            return newState;

        case HOME_PRODUCT_UPDATES_FETCH_ERROR:
            newState = state.mergeIn([productUpdates], Map({
                isFetching: action.isFetching,
                error: action.error,
                errorMessage: action.errorMessage,
                issue: action.issue,
                issuePayload: fromJS(action.issuePayload)
            }));
            return newState;

        default:
            return state;
    }
};

export default home;
